import { useNotifications } from "../components/shared/NotificationsProvider";
import { ApiError } from "./api";

// Wrap an async backend call. On error, shows a red toast with the server
// message; otherwise resolves with the result. Use it everywhere a button
// triggers an API mutation so the user always sees what went wrong.
export function useApiCall() {
  const { toast } = useNotifications();
  async function run<T>(
    fn: () => Promise<T>,
    opts?: { successMessage?: string },
  ): Promise<T | null> {
    try {
      const result = await fn();
      if (opts?.successMessage) toast(opts.successMessage, "success");
      return result;
    } catch (err) {
      const message =
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : "Something went wrong.";
      toast(message, "error");
      return null;
    }
  }
  return { run };
}
